import React from 'react';
import './App.css';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Bills from './pages/Bills/Bills';
import BillDetail from './pages/BillDetail/BillDetail';
import Legislators from './pages/Legislators/Legislators';
import NotFound from './pages/NotFound';
import Homepage from './pages/Homepage/Homepage';
import Route from './Route';
import Resources from './pages/Resources/Resources';

function App() {
  return (
    <div>
      <Header />
      <Route path="/">
        <Homepage />
      </Route>
      <Route path="/bills">
        <Bills />
      </Route>
      <Route path="/details">
        <BillDetail />
      </Route>
      <Route path="/legislators">
        <Legislators />
      </Route>
      <Route path="/resources">
        <Resources />
      </Route>
      <Route path="*">
        <NotFound />
      </Route>
      <Footer />
    </div>
  );
}

export default App;
